var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "firstmilemgmt"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Notaddedtothetrip",
      "id": "subchck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "subchck1"
    }
  }, [_vm._v("Not added to the trip(" + _vm._s(_vm.totalCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse",
      modifiers: {
        "collapse": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse"
    }
  }, [(_vm.firstmileallcationscanawb == false) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Client Short/ Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "CompanyList",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.ClientName),
      callback: function($$v) {
        _vm.ClientName = $$v
      },
      expression: "ClientName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "awb",
      "id": "awb",
      "placeholder": "Enter upto 10 AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pickup Date From ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupFromDate),
      expression: "pickupFromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "pickupFromDate"
    },
    domProps: {
      "value": (_vm.pickupFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupFromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pickup Date To ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupToDate),
      expression: "pickupToDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "pickupToDate"
    },
    domProps: {
      "value": (_vm.pickupToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupToDate = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupPincode),
      expression: "pickupPincode"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "pattern": "^(\\d{6})$",
      "maxlength": 6,
      "placeholder": "Enter Pickup Pincode",
      "name": "pickupPincode"
    },
    domProps: {
      "value": (_vm.pickupPincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupPincode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.AWBStatusFilterList,
      "placeholder": "Select AWB status",
      "append-to-body": true,
      "name": "AWBStatus"
    },
    model: {
      value: (_vm.AWBStatusFilter),
      callback: function($$v) {
        _vm.AWBStatusFilter = $$v
      },
      expression: "AWBStatusFilter"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "15px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanawbcheck),
      expression: "scanawbcheck"
    }],
    attrs: {
      "type": "checkbox",
      "name": "firstmilescanawbcheckbox",
      "id": "firstmilescanawbcheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.scanawbcheck) ? _vm._i(_vm.scanawbcheck, null) > -1 : (_vm.scanawbcheck)
    },
    on: {
      "click": _vm.scanawb,
      "__c": function($event) {
        var $$a = _vm.scanawbcheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.scanawbcheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.scanawbcheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.scanawbcheck = $$c
        }
      }
    }
  }), _vm._v(" Scan AWB\n\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "13px"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPageChange(1, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.firstmileallcationscanawb == true) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanAWB),
      expression: "scanAWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "firstmilescanawb",
      "id": "firstmilescanawb",
      "placeholder": "Enter AWB No"
    },
    domProps: {
      "value": (_vm.scanAWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getscanAWBForFirstmile()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scanAWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getscanAWBForFirstmile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "15px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanawbcheck),
      expression: "scanawbcheck"
    }],
    attrs: {
      "type": "checkbox",
      "name": "firstmilescanawbcheckbox",
      "id": "firstmilescanawbcheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.scanawbcheck) ? _vm._i(_vm.scanawbcheck, null) > -1 : (_vm.scanawbcheck)
    },
    on: {
      "click": _vm.scanawb,
      "__c": function($event) {
        var $$a = _vm.scanawbcheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.scanawbcheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.scanawbcheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.scanawbcheck = $$c
        }
      }
    }
  }), _vm._v(" Scan AWB\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "black",
      "padding": "5px 0px 5px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Filtered Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Selected Records: " + _vm._s(_vm.selectedAWB.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-input-group', [(_vm.parentOBj.tripStatus != 'closed') ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Assign To The Trip"
    },
    on: {
      "click": _vm.addFirstMileBooking
    }
  }, [_vm._v("\n                      Assign To The Trip")]) : _vm._e(), _vm._v(" "), (_vm.parentOBj.tripStatus == 'closed') ? _c('button', {
    staticClass: "-btn btn-success disabled",
    staticStyle: {
      "float": "right",
      "opacity": "0.5"
    },
    attrs: {
      "type": "button",
      "title": _vm.parentOBj.tripStatus == 'start' ? '' : 'Trip is in closed condition, AWBs for pickup can be added only when the trip is in created or started state'
    }
  }, [_vm._v("\n                        Assign To The Trip")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.awberr))])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllSelected),
      expression: "isAllSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllSelected) ? _vm._i(_vm.isAllSelected, null) > -1 : (_vm.isAllSelected)
    },
    on: {
      "click": _vm.selectAll,
      "__c": function($event) {
        var $$a = _vm.isAllSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("AWB Status")]), _vm._v(" "), _c('th', [_vm._v("User Process")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("Total Physical Weight (kg)")]), _vm._v(" "), _c('th', [_vm._v("Requested Pickup Date ")]), _vm._v(" "), _c('th', [_vm._v("Re-schedule Date ")]), _vm._v(" "), _c('th', [_vm._v("Shipment Tags")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableItems), function(data) {
    return [_c('tr', {
      class: {
        "text-primary": true,
        "rowdisable": data.AlreadyAssign == 1 || data.NumberofMPS == null || data.TotalWeight == null || data.disable == 1 || data.disable == 2 || data.disable == 5
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "title": data.AlreadyAssign ? ("AWB already assigned to tripid " + (data.TripId)) : !data.NumberofMPS ? "Number of MPS is empty" : !data.TotalWeight ? "Total Weight is empty" : data.disable == 1 ? ("Pick-up Scheduled at " + (data.pickupslotsdate)) : data.disable == 2 ? "Reallocation not allowed" : ''
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedAWB),
        expression: "selectedAWB"
      }],
      attrs: {
        "disabled": data.AlreadyAssign == 1 || data.NumberofMPS == null || data.TotalWeight == null || data.disable == 1 || data.disable == 2 || data.disable == 5,
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedAWB) ? _vm._i(_vm.selectedAWB, data) > -1 : (_vm.selectedAWB)
      },
      on: {
        "click": _vm.select,
        "__c": function($event) {
          var $$a = _vm.selectedAWB,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedAWB = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedAWB = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedAWB = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      class: data.AlreadyAssign == 1 || data.NumberofMPS == null || data.TotalWeight == null || data.disable == 1 || data.disable == 2 || data.disable == 5 ? "disabled" : "enabled"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      attrs: {
        "title": data.AlreadyAssign ? ("AWB already assigned to tripid " + (data.TripId)) : !data.NumberofMPS ? "Number of MPS is empty" : !data.TotalWeight ? "Total Weight is empty" : data.disable == 1 ? ("Pick-up Re-Scheduled on " + (data.pickupslotsdate)) : data.disable == 2 ? "Reallocation not allowed" : data.disable == 5 ? data.disablereason : ''
      }
    }, [_c('b-badge', {
      attrs: {
        "variant": "warn_info"
      }
    }, [_vm._v(_vm._s(data.WayBill))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.AWBStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NumberofMPS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.TotalPhyWt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickupslotsdate))]), _vm._v(" "), (data.pickupslotsdate != null && data.isreallocationallowed == true) ? _c('td', [_vm._v(_vm._s(data.pickupslotsdate))]) : _vm._e(), _vm._v(" "), (data.pickupslotsdate == null || data.isreallocationallowed == false || data.isreallocationallowed == null) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('td', [(data.isopenpickupdelivery == 1) ? _c('b-badge', {
      staticClass: "common-otp-primary",
      attrs: {
        "variant": "secondary",
        "title": "Open Pickup"
      }
    }, [_vm._v("OP "), (data.clientmpsitemqty) ? _c('span', [_vm._v("(" + _vm._s(data.clientmpsitemqty) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')], 1)])]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('pagination', {
    staticClass: "pagination",
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Addedtothetrip",
      "id": "subchck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "subchck2"
    }
  }, [_vm._v("Added to the trip(" + _vm._s(_vm.selectedAWBCount ? _vm.selectedAWBCount : 0) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse1",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AddedAWB),
      expression: "AddedAWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB No"
    },
    domProps: {
      "value": (_vm.AddedAWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getSelectedAWBForTrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AddedAWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB Created Date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBRADDateRange),
      expression: "AWBRADDateRange"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "AWBRADDateRange"
    },
    domProps: {
      "value": (_vm.AWBRADDateRange)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBRADDateRange = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.AWBStatuslist,
      "placeholder": "Select AWB Status",
      "append-to-body": true,
      "name": "AWBStatus"
    },
    model: {
      value: (_vm.AWBStatus),
      callback: function($$v) {
        _vm.AWBStatus = $$v
      },
      expression: "AWBStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Pincodelist,
      "placeholder": "Select Pincode",
      "append-to-body": true,
      "name": "tempPincode"
    },
    model: {
      value: (_vm.tempPincode),
      callback: function($$v) {
        _vm.tempPincode = $$v
      },
      expression: "tempPincode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client Short/ Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "ClientName",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.AddedClientName),
      callback: function($$v) {
        _vm.AddedClientName = $$v
      },
      expression: "AddedClientName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getSelectedAWBForTrip()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "black",
      "padding": "0px 0px 5px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Filtered Records: " + _vm._s(_vm.selectedAWBCount ? _vm.selectedAWBCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Selected Records: " + _vm._s(_vm.selectedRemoveAWB.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedRemoveAWB.length == 0,
      "title": "Print AWB"
    },
    on: {
      "click": _vm.printMultipleAwb
    }
  }, [_vm._v("\n                      Print AWB")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-input-group', [(_vm.parentOBj.tripStatus == 'created') ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Remove From The Trip"
    },
    on: {
      "click": _vm.removeFirstMileBooking
    }
  }, [_vm._v("\n                          Remove From The Trip")]) : _vm._e(), _vm._v(" "), (_vm.parentOBj.tripStatus != 'created') ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": "",
      "title": "Remove From The Trip"
    }
  }, [_vm._v("\n                          Remove From The Trip")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.removeawberr))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllAddedSelected),
      expression: "isAllAddedSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllAddedSelected) ? _vm._i(_vm.isAllAddedSelected, null) > -1 : (_vm.isAllAddedSelected)
    },
    on: {
      "click": _vm.selectAllAdded,
      "__c": function($event) {
        var $$a = _vm.isAllAddedSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllAddedSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllAddedSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllAddedSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("AWB Status")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("Total Physical Weight (kg)")]), _vm._v(" "), _c('th', [_vm._v("AWB Created Date")]), _vm._v(" "), _c('th', [_vm._v("Requested Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("Shipment Tags")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.seletedAWB), function(data) {
    return [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRemoveAWB),
        expression: "selectedRemoveAWB"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedRemoveAWB) ? _vm._i(_vm.selectedRemoveAWB, data) > -1 : (_vm.selectedRemoveAWB)
      },
      on: {
        "click": _vm.selectRemove,
        "__c": function($event) {
          var $$a = _vm.selectedRemoveAWB,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRemoveAWB = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedRemoveAWB = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRemoveAWB = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.WayBill))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.AWBStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Pincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NumberofMPS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.TotalWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormat(data.AWBRADDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.requestedpickupdate))]), _vm._v(" "), _c('td', [(data.isopenpickupdelivery == 1) ? _c('b-badge', {
      staticClass: "common-otp-primary",
      attrs: {
        "variant": "secondary",
        "title": "Open Pickup"
      }
    }, [_vm._v("OP"), (data.clientmpsitemqty) ? _c('span', [_vm._v("(" + _vm._s(data.clientmpsitemqty) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "-btn btn-primary",
      attrs: {
        "type": "button",
        "title": "Print AWB"
      },
      on: {
        "click": function($event) {
          _vm.printAWBPage(data.AWB)
        }
      }
    }, [_vm._v("Print AWB "), _c('i', {
      staticClass: "fa fa-print"
    })]), _vm._v("  \n                    ")])])]
  })], 2)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('pagination', {
    staticClass: "pagination",
    attrs: {
      "total-pages": _vm.totalPage2,
      "total": _vm.totalCount2,
      "per-page": _vm.pageLimit2,
      "current-page": _vm.currentPage2
    },
    on: {
      "pagechanged": _vm.onPageChange2
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showAWBNotAdded = false
      }
    },
    model: {
      value: (_vm.showAWBNotAdded),
      callback: function($$v) {
        _vm.showAWBNotAdded = $$v
      },
      expression: "showAWBNotAdded"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Warning:AWBs not added to trip")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showAWBNotAdded = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', [_c('label', [_vm._v("Below AWBs were not added to the trip due to expired EWBs or PART B not updated")])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("EWB")]), _vm._v(" "), _c('th', [_vm._v("Failure Reason")])])]), _vm._v(" "), _vm._l((_vm.expireEBN), function(data) {
    return _c('tbody', [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ewb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.reason))])])])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAWBNotAdded = false
      }
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), (_vm.showPrintPage) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('LR-Copy', {
    attrs: {
      "selectedData": _vm.bookingData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isMultiPrint) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    attrs: {
      "id": "printMultiple"
    }
  }, _vm._l((_vm.printMultipleAwbs), function(item) {
    return _c('LR-Copy', {
      key: item.awbnumber,
      attrs: {
        "selectedData": item
      }
    })
  }))]) : _vm._e()])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d920379","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/AddShipments/firstmilemgmt/firstmilemgmt.component.html
// module id = 1321
// module chunks = 3